import { Pipe, PipeTransform } from '@angular/core';
import { Nullish, invertBool$ } from '@siza-staff-care/shared/utils';
import { Observable, isObservable, of } from 'rxjs';

@Pipe({
	name: 'invert',
	standalone: true,
})
export class InvertPipe implements PipeTransform {
	/**
	 * Inverts a boolean value or Observable&lt;boolean&gt; returning an Observable<boolean>.
	 */
	transform(value: (() => boolean) | boolean | Nullish | Observable<boolean>): Observable<boolean> {
		if (value === undefined || value === null) {
			return of(true);
		}

		if (isObservable(value)) {
			return invertBool$(value);
		}

		return of(typeof value === 'function' ? !value() : !value);
	}
}
